import development from "../../../assets/images/about/development.png";

const Development = () => (
  <div className="flex justify-center items-center h-screen md:h-120 lg:h-screen bg-blue-850 text-white mb-10 md:mb-0">
    <div className="flex flex-col md:flex-row md:justify-center px-10 lg:px-0 lg:w-4/5 h-1/2 mx-auto md:-mt-20">
      <img src={development} alt="Development" className="w-full md:w-1/3" />

      <div className="bg-blue-750 bg-opacity-80 p-4 xl:p-6">
        <h4 className="text-2xl lg:text-3xl xl:text-4xl mb-2 lg:mb-4 xl:mb-5">
          Our Development Programs
        </h4>

        <p className="text-xs md:text-sm lg:text-base xl:text-lg">
          Within the ever-changing world of technology constantly something new
          to learn. NABAZAT AL QALB is always update its employees by providing them
          a chance developments and trends within the company employees to use
          new tools and develop new company to a more challenging level and
          higher r training programs through some international acad Through
          these development programs and trainings. NABAZAT AL QALB tries to achieve
          such as increasing productivity, providing long-life learning,
          ensuring smooth operation and employee satisfaction among all
          departments.
        </p>
      </div>
    </div>
  </div>
);

export default Development;
